module.exports = function (data, value) {
    let text = 'Не удалось получить ответ с сервером';
    if (value) {
        if (value.text) text = value.text;
    }
    let error = '';
    if (!data) {
        error = text;
    } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
        error = data.ResultQueryInfo.UserMessages;
    }
    if (error) {
        window.app.$notify.error({
            title: 'Ошибка',
            message: error,
        });
    }
    return !!error;
};